import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { useFragment, graphql } from 'react-relay';
import { ResolvedDate as ResolvedDateFieldReadView } from '@atlassian/jira-resolved-date/src/ui/read/main.tsx';
import type { ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField$key } from './__generated__/ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField.graphql';

export interface IssueViewResolvedDateFieldProps {
	fragmentKey: ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField$key;
}

export const IssueViewResolvedDateField = ({
	fragmentKey,
}: IssueViewResolvedDateFieldProps): React.JSX.Element | null => {
	const data = useFragment<ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField on JiraDateTimePickerField {
				dateTime
			}
		`,
		fragmentKey,
	);

	if (!data.dateTime) {
		return null;
	}

	return <ResolvedDateFieldReadView date={data.dateTime} />;
};
